import { render, staticRenderFns } from "./FormInputNumber2.vue?vue&type=template&id=9dbfedd0&scoped=true&"
import script from "./FormInputNumber2.vue?vue&type=script&lang=js&"
export * from "./FormInputNumber2.vue?vue&type=script&lang=js&"
import style0 from "./FormInputNumber2.vue?vue&type=style&index=0&id=9dbfedd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dbfedd0",
  null
  
)

export default component.exports